import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = useState(false);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  return (
    <>
      <TopBar onMenuClick={handleDrawerToggle} />
      <Sidebar open={open} onClose={handleDrawerToggle} />
      {children}
    </>
  );
};
